import { ReactNode, useEffect, useRef } from "react";

import { Box, Stack, StackProps, styled } from "@mui/material";
import { base } from "configs/colors";
import { rem } from "utils";

interface Props {
  children?: ReactNode;
  wrapperProps?: StackProps;
}

const Wrapper = styled(Stack)(() => ({
  borderTopLeftRadius: "40px",
  "&.sticky": {
    position: "sticky",
    boxShadow: "0px 10px 15px -10px rgba(16, 24, 40, 0.05)",
  },
}));

const IndexComponent: React.FC<Props> = ({ children, wrapperProps }) => {
  const sentinalElm = useRef<HTMLDivElement | null>(null);
  const wrapperElm = useRef<HTMLDivElement | null>(null);

  useEffect(function init() {
    const sentinal = sentinalElm.current;
    const warpper = wrapperElm.current;
    if (!sentinal || !warpper) return;
    const observer = new IntersectionObserver(
      ([e]) => {
        warpper.classList[!e.isIntersecting ? "add" : "remove"]("sticky");
      },
      { root: null, threshold: 0 }
    );
    observer.observe(sentinal);
    // eslint-disable-next-line consistent-return
    return () => {
      observer.unobserve(sentinal);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box ref={sentinalElm} position="relative" top={rem(-32)} />
      <Wrapper
        ref={wrapperElm}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        bgcolor={base.White}
        gap={rem(12)}
        top={0}
        margin={rem(-32)}
        padding={`${rem(24)} ${rem(32)}`}
        zIndex={10}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...(wrapperProps ?? {})}
      >
        {children}
      </Wrapper>
    </>
  );
};

export default IndexComponent;
